<template>
  <div>
    <b-modal
      id="login-token-modal"
      ref="login-token-modal-ref"
      hide-footer
      title="Login"
    >
      <b-form
        class="login-form"
        @submit.stop.prevent="onSubmit"
      >
        <div class="vtd-card-block-token">
          <FlashMessage />

          <div v-if="!confirmId && !needsSubmitter">
            <p class="vtd-card-title-token">
              In order to access your personal information and booking history
              on ViewTrail, you will need a one time passcode.
            </p>
            <p class="vtd-card-title-token">
              Please select from one of the below contact options associated
              with this booking and press 'Send Code'.
            </p>
            <p class="vtd-card-title-token">
              Once received, please enter the code we send you within 20 minutes
              of receiving it, otherwise you will need to generate a new one.
            </p>
            <!-- <p class="vtd-card-title-token">
              If you have any problems, please send us an <a class="etrail-link" @click="openModal('EtrailRef')">e-trail</a>
            </p> -->
            <b-form-group
              label-for="input-username"
              class="vtd-form-group"
              label="Preferred Contact Method"
            >
              <b-form-select
                v-model.trim="$v.form.loginOption.$model"
                :options="loginOptions"
                :state="validateState('loginOption')"
              />
            </b-form-group>
          </div>

          <div v-if="!confirmId && needsSubmitter">
            <p class="vtd-card-title-token">
              {{ verificationText }}
            </p>
            <p class="vtd-card-title-token">
              Booking Number {{ bookingNumber }}
            </p>

            <b-form-group
              :label="submitterLabel"
              label-for="input-username"
              class="vtd-form-group"
            >
              <b-form-select
                v-model.trim="$v.form.passenger.$model"
                :options="paxNameOptions"
                :state="validateState('passenger')"
                value="name"
                @change="$emit('passSetPassenger',$v.form.passenger.$model)"
              />
            </b-form-group>

            <b-form-group
              label="Preferred Contact Method"
              label-for="input-username"
              class="vtd-form-group"
            >
              <b-form-select
                v-model.trim="$v.form.loginOption.$model"
                :options="loginOptions"
                :state="validateState('loginOption')"
              />
            </b-form-group>
          </div>

          <div v-if="confirmId">
            <p class="vtd-card-title-token">
              Please enter the one time passcode we have just sent. This is only
              valid for a period of 20 minutes.
            </p>
            <b-form-group
              v-if="confirmId"
              label-for="input-code"
              class="vtd-form-group"
            >
              <b-form-input
                id="input-code"
                v-model.trim="$v.form.code.$model"
                type="text"
                class="vtd-form-control vtd-form-control-lg"
                :state="validateState('code')"
                placeholder="Code"
              />
            </b-form-group>
          </div>

          <div class="vtd-card-footer-token">
            <b-button
              type="submit"
              class="login-btn-token"
            >
              <span v-if="!confirmId">Send Code</span>
              <span v-if="confirmId">Submit</span>
            </b-button>
            <b-button
              v-if="confirmId"
              type="button"
              class="login-btn-token"
              @click="resetForm"
            >
              <span>Send Another Code</span>
            </b-button>
          </div>
        </div>
      </b-form>
    </b-modal>
    <ResetPassword ref="ResetPasswordRef" />
    <RegisterUser ref="RegisterRef" />
    <Faq
      ref="FaqRef"
      :show-etrail="
        () => {
          this.$refs['EtrailRef'].show();
        }
      "
    />
    <Etrail
      ref="EtrailRef"
      :booking="booking"
      source="loginToken"
    />
  </div>
</template>

<script>
import { createLogger, mapActions, mapGetters } from "vuex";
import { requiredIf } from "vuelidate/lib/validators";
import FlashMessage from "@/partials/flash-message";
import router from "@/router";
import ResetPassword from "@/modules/auth/reset-password";
import Register from "@/modules/auth/register";
import Faq from "@/modules/booking/faq";
import Etrail from "@/partials/contact-us/etrail";
import store from "@/modules/auth/store";
import { getTravellingPassengers } from '../../../lib/utilities';

export default {
  components: {
    FlashMessage,
    ResetPassword,
    RegisterUser: Register,
    Faq,
    Etrail,
  },
  props: {
    cancellation: { type: Boolean, default: false },
    // Generalises cancellation's "select who you are, then verify" UI for
    // other callers (Communications) that also need to know exactly which
    // passenger is verifying, not just that someone with booking access did.
    requireSubmitter: { type: Boolean, default: false },
    modalText: { type: String, default: "" },
    submitterLabel: { type: String, default: "Submitter" },
  },
  data() {
    return {
      authorisedCallback: null,
      destination: null,
      form: {
        loginOption: "",
        passenger: {},
        code: "",
      },
    };
  },
  validations: {
    form: {
      loginOption: {
        requiredIf: requiredIf(function () {
          return !this.confirmId;
        }),
      },
      passenger: {

        requiredIf: requiredIf(function () {
          return this.cancellation || this.requireSubmitter;
        }),


      },
      code: {
        requiredIf: requiredIf(function () {
          return this.confirmId;
        }),
      },  
    },
  },
  computed: {
    ...mapGetters({
      authorised: "auth/isAuthorisedWithToken",
      booking: "booking/getBooking",
      bookingNumber: "booking/getBookingNumber",
      loginOptions: "auth/getLoginOptions",
      confirmId: "auth/getConfirmId",
      paxNames: "booking/getBookingPassengers",
    }),
    paxNameOptions() {
      if (this.paxNames && this.paxNames.length) {
        let mapOptions =  this.paxNames.map((pax) => { return {text: pax.name, value:pax }})
        mapOptions.unshift({text: 'Select Passenger', value: '' , disabled: true})
        return mapOptions
      } else {
        return [{text: 'Select Passenger', value: '' , disabled: true}]
      }
    },
    needsSubmitter() {
      return this.cancellation || this.requireSubmitter;
    },
    verificationText() {
      if (this.modalText) return this.modalText;
      return "Prior to you submitting a cancellation notification, we need to verify who you are. Please select your name from the below list of people travelling, and the preferred contact details to contact you on. We will send you a One Time Passcode which you will need in order to proceed.";
    },
  },
  watch: {
    authorised: function () {
      if (this.authorised && this.authorisedCallback) {
        this.$refs["login-token-modal-ref"].hide();
        this.authorisedCallback();
        this.authorisedCallback = null;
      }
    },
  },
  methods: {
    openModal(item) {
      this.$refs[item].show();
    },
    authCheckGo(destination) {
      this.authorisedCallback = null;
      if (!this.authorised) {
        this.destination = destination;
        this.$refs["login-token-modal-ref"].show();
      } else {
        router.push(destination);
      }
    },
    // This method just either displays the login prompt or returns true to indicate already logged in
    authCheckResult(callback) {
      if (!this.authorised) {
        this.$refs["login-token-modal-ref"].show();
        this.authorisedCallback = callback;
      } else {
        callback();
      }
    },
    // Unlike authCheckGo/authCheckResult, this always shows the prompt -
    // an existing token from Profile/All Bookings/etc doesn't say which
    // passenger it was, so it can't be trusted here. Clearing the token
    // (not just confirmId) is what makes the `authorised` watcher above
    // fire again once a fresh code is confirmed - if it were left set
    // (already true), a fresh confirm wouldn't change that boolean, and
    // the callback would never run. Requires the "requireSubmitter" prop
    // to be set on this component so the passenger dropdown shows too.
    authCheckCommunications(callback) {
      this.authorisedCallback = callback;
      this.destination = null;
      this.$store.dispatch("auth/resetConfirmId", null, { root: true });
      this.$store.dispatch("auth/clearTokenAction", null, { root: true });
      this.$refs["login-token-modal-ref"].show();
    },
    async onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      if (!this.confirmId) {
        this.sendCode({
          codeDestination: this.form.loginOption,
          bookingNumber: this.bookingNumber,
        });
        this.$v.$reset();
      } else {
        this.confirmCode({
          code: this.form.code,
          confirmId: this.confirmId,
          destination: this.destination,
        });
      }
    },
    ...mapActions({
      sendCode: "auth/loginSendCodeAction",
      confirmCode: "auth/loginConfirmCodeAction",
    }),
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.$store.dispatch("auth/resetConfirmId", true, { root: true });
      (this.authorisedCallback = null),
        (this.destination = null),
        (this.form = {
          loginOption: "",
          code: "",
        });
      this.$v.$reset();
    },
  },
};
</script>

<style lang="scss">
@import "./styles.scss";
</style>
